// 商品路由
const name = '店铺端'

export default {
  path: '/shopadmin/shoplist',
  component: () => import( '@/view/shoplist' )
}
